// extracted by mini-css-extract-plugin
export default {"project":"Project_project__HYb8v","p":"Project_p__DdQ28"};